module.exports = __webpack_public_path__ + "img/pc_func3.4dc31fdf.png";